import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Paper from "@material-ui/core/Paper";

import Tab from "@material-ui/core/Tab";

import "./Header.css";
import { Link } from "react-router-dom";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import SimpleModal from "../Modal/Modal";
import { isMobile } from "react-device-detect";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      imageWidth: 150,
      imageStyle: "ImageHeader",
      open: false
    };
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    const { scrollY } = window;
    const { active } = this.state;
    if (scrollY < 70) {
      //  if (window.innerHeight <= 700) {
      this.setState({ imageStyle: "ImageHeader" });
      //  } else {
      //    this.setState({ imageHeight: 250 });
      //   }
    } else {
      // if (window.innerHeight <= 700) {
      this.setState({ imageStyle: "ImageHeaderSmall" });
      // } else {
      //   this.setState({ imageHeight: 200 });
      // }
    }
  };

  onOpenVideoPlayer = () => {
    this.setState({ modalOpen: true });
  };

  onCloseVideoPlayer = () => {
    this.setState({ modalOpen: false });
  };

  render() {
    return (
      <div className={isMobile ? "HeaderMobile" : "Header"}>
        <Link to="/?redirect=true">
          <div className="LinkHeader"></div>
        </Link>
        {isMobile ? (
          <React.Fragment>
            <div className="MenuNavBar">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.handleClick}
                className="MenuButton"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                open={this.state.open}
                onClose={this.handleClose}
                className="MenuNav"
                anchorEl={this.state.anchorEl}
              >
                <MenuItem key={"1"} selected={false} onClick={this.handleClose}>
                  {"COMO COMPRAR"}
                </MenuItem>
                <MenuItem key={"2"} selected={false} onClick={this.handleClose}>
                  {"AUTOS EN STOCK"}
                </MenuItem>
                <MenuItem
                  key={"3"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"COROLLA"}
                </MenuItem>
                <MenuItem
                  key={"4"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"ETIOS"}
                </MenuItem>
                <MenuItem
                  key={"5"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"YARIS"}
                </MenuItem>
                <MenuItem
                  key={"6"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"HILUX"}
                </MenuItem>
                <MenuItem
                  key={"7"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"SW4"}
                </MenuItem>
                <MenuItem
                  key={"8"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"RAV4"}
                </MenuItem>
                <MenuItem key={"9"} selected={false} onClick={this.handleClose}>
                  {"FAQ"}
                </MenuItem>
                <MenuItem
                  key={"10"}
                  selected={false}
                  onClick={this.handleClose}
                >
                  {"CONTACTO"}
                </MenuItem>
                ))
              </Menu>
            </div>
          </React.Fragment>
        ) : (
          <div>
            <div className="Button-container">
              <Link to="/?redirect=true">
                <div className="Button-header">AUTOS EN STOCK</div>
              </Link>{" "}
              <img src="/img/divider.png" className="Divider" />
              <Link onClick={this.onOpenVideoPlayer}>
                <div className="Button-header">¿CÓMO COMPRAR? </div>
              </Link>
              <img
                src="/img/cero-vueltas.png"
                className={this.state.imageStyle}
                //style={{ height: this.state.imageHeight }}
              />
            </div>

            <SimpleModal
              open={this.state.modalOpen}
              onClose={this.onCloseVideoPlayer}
            >
              <VideoPlayer />
            </SimpleModal>
          </div>
        )}
      </div>
    );
  }
}

export default Header;
